module.exports = __webpack_public_path__ + "static/media/checkbox1.32fbf327.svg";